import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatDropdownButton = createCustomElementWrapper('kat-dropdown-button', 'KatDropdownButton', {
    'singleTarget': 'single-target',
    'singleTargetIcon': 'single-target-icon',
    'singleTargetLabel': 'single-target-label',
}, {
    'onAction': 'action',
    'onCollapse': 'collapse',
    'onExpand': 'expand',
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/dropdown-button.js
// module id = 1260
// module chunks = 0